import { createGlobalStyle } from 'styled-components';

const ResetStyles = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
  }
  button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    outline: none;
    padding: 0;
    appearance: none;
 }
 h1, h2 {
    margin: 0;
    padding: 0;
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    text-decoration: none;
  }
  p {
    margin: 0;
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
`;

export default ResetStyles;
